import {combineReducers} from 'redux';
import {connectRouter} from 'connected-react-router';
import Settings from './Setting';
import Common from './Common';
import Dashboard from './Dashboard';
import UserInfo from './UserInfo';
import UserManagement from './UserManagement';
import SettingParameter from './SettingParameter';
import cpcVaultingCashPickUpReducers from './cpcVaultingCashPickUp';
import orderCashPickUpSortasiReducers from './orderCashPickUpSortasi';
import serviceCashPickUpReducers from './serviceCashPickUp';
import FormKlarifikasi from './FormKlarifikasi';
import OrderReplenishment from './OrderReplenishment';
import cpcMaker from './cpcMaker';
import citExecutorCashDelivery from './citExecutorCashDelivery';
import cpcVaultingCashReplenishment from './cpcVaultingCashReplenishment';
import orderCashReturnAssign from './orderCashReturnAssign';
import orderReturnNoSeal from './orderReturnNoSeal';
import repairNoSealCashMovementReducers from './repairNoSealCashMovement';
import TransactionMonitoring from './TransactionMonitoring';
import cashReplenishmentAcceptanceReducers from './cashReplenishmentAcceptance';
import orderCashMovementAssigns from './orderCashMovementAssign';
import cashMovementNoSeals from './cashMovementNoseal';
import cpcVaultingMovement from './cpcVaultingMovement';
import loadingScreen from './loadingScreen';
import userMustChangePassword from './UserMustChangePassword'

const reducers = (history) =>
  combineReducers({
    router: connectRouter(history),
    settings: Settings,
    common: Common,
    dashboard: Dashboard,
    userInfo: UserInfo,
    userManagement: UserManagement,
    settingParameter: SettingParameter,
    cpcVaultingCashPickUp: cpcVaultingCashPickUpReducers,
    orderCashPickUpSortasi: orderCashPickUpSortasiReducers,
    serviceCashPickUp: serviceCashPickUpReducers,
    formKlarifikasi: FormKlarifikasi,
    orderReplenishment: OrderReplenishment,
    cpcMaker: cpcMaker,
    citExecutorCashDelivery: citExecutorCashDelivery,
    cpcVaultingCashReplenishment: cpcVaultingCashReplenishment,
    orderCashReturnAssign: orderCashReturnAssign,
    orderReturnNoSeal: orderReturnNoSeal,
    repairNoSealCashMovement: repairNoSealCashMovementReducers,
    transactionMonitoring: TransactionMonitoring,
    cashReplenishmentAcceptance: cashReplenishmentAcceptanceReducers,
    orderCashMovementAssign: orderCashMovementAssigns,
    cashMovementNoSeal: cashMovementNoSeals,
    cpcVaultingMovement: cpcVaultingMovement,
    loadingScreen,
    userMustChangePassword: userMustChangePassword,
  });
export default reducers;
